import propTypes from 'prop-types';
import { inject } from 'mobx-react';

const _ObsoletePriceMsg = ({ optionsStore, labelsStore }) => (
  optionsStore.contactSalesURL
    ? (
      <a href={optionsStore.contactSalesURL} className="cart-link pes-link cart-link--obsolete">
        {labelsStore.contactSalesLabel}
      </a>
    ) : null
);

_ObsoletePriceMsg.propTypes = {
  optionsStore: propTypes.shape({
    contactSalesURL: propTypes.string
  }).isRequired,
  labelsStore: propTypes.shape({
    contactSalesLabel: propTypes.string.isRequired
  }).isRequired
};

export const ObsoletePriceMsg = inject((allStores) => ({
  optionsStore: allStores.optionsStore,
  labelsStore: allStores.labelsStore
}))(_ObsoletePriceMsg);
